import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=677e5376&"
import script from "./CardsView.vue?vue&type=script&lang=ts&"
export * from "./CardsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports